import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Cutout} from "../types/Cutout";

export const useGetCutouts = (dealerID: number, prodQteGrpID: number, zipCode: string) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-pro-cutouts', prodQteGrpID, dealerID, zipCode],
        queryFn: async () => await apiClient.get('ee-pro/cutouts?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&zipCode=' + zipCode) as Cutout[],
        enabled: prodQteGrpID > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
